import { Link01, UserPlus02 } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import Button from "@/components/forms/Button";
import Legend from "@/components/helpers/Legend";

type GroupMemberActionsProps = {
  onAddUsers: () => void;
  onInviteLink: () => void;
};

export default function GroupMemberActions({
  onAddUsers,
  onInviteLink,
}: GroupMemberActionsProps) {
  const { t } = useTranslation("messenger.user");

  return (
    <>
      <div className="cursor-pointer p-6 hover:bg-gray-50" onClick={onAddUsers}>
        <Button
          color="link-color"
          size="sm"
          startIcon={<UserPlus02 className="size-5" />}
        >
          {t("Add Users")}
        </Button>
      </div>
      <Legend className="mx-6" />
      <div
        className="cursor-pointer p-6 hover:bg-gray-50"
        onClick={onInviteLink}
      >
        <Button
          color="link-color"
          size="sm"
          startIcon={<Link01 className="size-5" />}
        >
          {t("Invite via Link")}
        </Button>
      </div>
      <Legend className="mx-6" />
    </>
  );
}
